module.exports = __webpack_public_path__ + "img/daycare-works-logo.9ef175d5.png";